import { createSlice } from "@reduxjs/toolkit";

// Define breakpoints to use consistently throughout the app
export const BREAKPOINTS = {
    MOBILE: 768,
    TABLET: 1000,
    DESKTOP: 1000,
    RESPONSIVE_MODE: 1000, // Main breakpoint for sidebar collapse
};

// Initial state with responsive breakpoints
const initialState = {
    isMobile: window.innerWidth < BREAKPOINTS.MOBILE,
    isTablet: window.innerWidth >= BREAKPOINTS.MOBILE && window.innerWidth < BREAKPOINTS.TABLET,
    isDesktop: window.innerWidth >= BREAKPOINTS.DESKTOP,
    isResponsiveMode: window.innerWidth < BREAKPOINTS.RESPONSIVE_MODE, // Equivalent to the previous responsive check
    width: window.innerWidth,
    height: window.innerHeight,
    isSidebarCollapsed: window.innerWidth < BREAKPOINTS.RESPONSIVE_MODE // Sidebar state based on responsive mode
};

// Create responsive slice
const responsiveSlice = createSlice({
    name: "responsive",
    initialState,
    reducers: {
        // Update all responsive states
        updateResponsiveState: (state, action) => {
            const { width, height } = action.payload;

            state.width = width;
            state.height = height;
            state.isMobile = width < BREAKPOINTS.MOBILE;
            state.isTablet = width >= BREAKPOINTS.MOBILE && width < BREAKPOINTS.TABLET;
            state.isDesktop = width >= BREAKPOINTS.DESKTOP;
            state.isResponsiveMode = width < BREAKPOINTS.RESPONSIVE_MODE;
        },

        // Toggle sidebar visibility
        toggleSidebar: (state) => {
            state.isSidebarCollapsed = !state.isSidebarCollapsed;
        },

        // Set sidebar collapsed state
        setSidebarCollapsed: (state, action) => {
            state.isSidebarCollapsed = action.payload;
        },

        // Handle sidebar state on resize
        handleResizeEffect: (state) => {
            if (state.isResponsiveMode) {
                state.isSidebarCollapsed = true;
            }
        }
    },
});

export const {
    updateResponsiveState,
    toggleSidebar,
    setSidebarCollapsed,
    handleResizeEffect
} = responsiveSlice.actions;

export default responsiveSlice.reducer; 